/* eslint no-shadow: 0 */
import Vue from 'vue';
import dfsService from '@/service/SurveyService';

export const namespaced = true;

export const state = {
  bgColor: '',
  themeColor: '',
  bgFontColor: '',
  themeFontColor: '',
  formID: '',
  companyID: '',
  memberSourceId: ''
};

export const getters = {
};

export const mutations = {
  set(state, data) {
    if (!state[data.id]) {
      Vue.set(state, data.id, data.value);
    } else {
      state[data.id] = data.value;
    }
  }
};

export const actions = {
  formCompany({ state, commit }) {
    const params = {
      formID: state.formID
    };
    return dfsService.getFormCompany(params).then((res) => {
      if (res && res.success && res.data && res.data[0]) {
        commit('set', { id: 'companyID', value: res.data[0].companyId });
        commit('set', { id: 'memberSourceId', value: res.data[0].memberSourceId });
      }
      return res;
    });
  },
  companyParam({ state }, payload) {
    const params = {
      companyId: state.companyID,
      formParamCode: payload.paramCode
    };
    return dfsService.getCompanyParams(params);
  },
  getFormLinkUrl(_, payload) {
    const body = {
      formId: payload.formId,
      customerID: payload.customerID
    };
    return dfsService.getFormLinkUrl(body);
  }
};
